export const muiAccordionTheme = {
  MuiAccordion: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.kit.background.lightpurple,
        borderRadius: 8,
        '& .MuiButtonBase-root': { paddingRight: '24px' },
        '&:not(:last-child)': {
          marginBottom: 12,
        },
        '&:before': {
          display: 'none',
        },
      }),
    },
  },
};
